import React, { useState } from 'react';
import { sendRadioReport } from './api';
import { ReportRadioBox, ReportMenu, SingleReport, ReportButton } from './ReportRadio.css';

interface IReportRadio {
  id: number;
}

const ReportRadio = (props: IReportRadio): JSX.Element => {
  const { id } = props;
  const [openMenu, setOpenMenu] = useState(false);
  const [sending, setSending] = useState(false);
  const [reportSent, setReportSent] = useState(false);

  const handleToggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleSendReport = async (report: number) => {
    const now = Date.now();
    setSending(true);
    await sendRadioReport(id, report);
    const timeout = 1000 - (Date.now() - now);
    setTimeout(() => {
      setSending(false);
      setReportSent(true);
      setTimeout(() => {
        setOpenMenu(false);
      }, 1500)
    }, timeout);
  }

  const renderContent = (): JSX.Element | void => {
    if (openMenu) {

      if (reportSent) {
        return <ReportMenu style={{padding: 5}}><i className="fas fa-check" style={{color: '#2E7D32'}} /> REPORT SENT</ReportMenu>
      }

      if (sending) {
        return <ReportMenu style={{padding: 5}}>SENDING...</ReportMenu>;
      }

      return (
        <ReportMenu>
          <SingleReport onClick={() => handleSendReport(0)}>NOT WORK</SingleReport>
          <SingleReport onClick={() => handleSendReport(1)}>BAD QUALITY</SingleReport>
        </ReportMenu>
      );
    }
  }

  return (
    <ReportRadioBox>
      <ReportButton onClick={handleToggleMenu}>
        <i style={{color: '#ddd'}} className="fas fa-flag"></i>
      </ReportButton>
      {renderContent()}
    </ReportRadioBox>
  );
};

export default ReportRadio;